module.exports = __webpack_public_path__ + "transport.77a32a67cb2e93eb783c.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/transport/webfont/transport.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/transport/webfont/transport.woff
// module chunks = styles